export const SIZE = {
  mobileMin: `360px`,
  mobileMax: `767px`,
  tablet: `768px`,
  desktop: `1024px`,
};

export const COLOR = {
  main_green: `#008037`,
  main_yellow: `#FFF2C2`,
  hover_green: `#309B4F`,
  hover_yellow: `#FFE37B`,
  gray_green: `#94BF88`,
};
